"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelEdge = void 0;
var react_1 = __importDefault(require("react"));
/**
 * LabelEdge - Component that only renders edge labels.
 * Used as a second pass to ensure labels appear above all edge paths.
 */
// Layout constants used to size the <foreignObject> wrapper. Kept here so the
// width estimation stays consistent with the rendered label styling below.
var FONT_SIZE_PX = 12;
var APPROX_CHAR_WIDTH_PX = 7.5; // 12px @ fontWeight 700, empirical
var HORIZONTAL_PADDING_PX = 16; // 8px * 2
var BORDER_WIDTH_PX = 2; // 1px * 2
var WRAPPER_HEIGHT_PX = 30;
var WRAPPER_VERTICAL_OFFSET_PX = 15;
var DEFAULT_PADDING_Y = 6;
var DEFAULT_PADDING_X = 8;
/** Midpoint of the straight line between source and target. */
function getMidpoint(sx, sy, tx, ty) {
    return { x: sx + (tx - sx) * 0.5, y: sy + (ty - sy) * 0.5 };
}
/** Estimate the rendered label width to size the SVG foreignObject. */
function estimateLabelWidth(text) {
    return text.length * APPROX_CHAR_WIDTH_PX + HORIZONTAL_PADDING_PX + BORDER_WIDTH_PX;
}
/**
 * Normalize React Flow's labelBgPadding (tuple, single number, or undefined)
 * into [vertical, horizontal] pixel values. Preserves original fallback semantics
 * (a 0 in either slot falls back to the default — matches prior behavior).
 */
function resolvePadding(padding) {
    var arr = padding;
    return [(arr === null || arr === void 0 ? void 0 : arr[0]) || DEFAULT_PADDING_Y, (arr === null || arr === void 0 ? void 0 : arr[1]) || DEFAULT_PADDING_X];
}
var wrapperStyle = {
    overflow: 'visible',
    pointerEvents: 'none',
};
var LabelEdgeComponent = function (_a) {
    var sourceX = _a.sourceX, sourceY = _a.sourceY, targetX = _a.targetX, targetY = _a.targetY, label = _a.label, data = _a.data, _b = _a.labelStyle, labelStyle = _b === void 0 ? {} : _b, _c = _a.labelBgStyle, labelBgStyle = _c === void 0 ? {} : _c, _d = _a.labelBgPadding, labelBgPadding = _d === void 0 ? [DEFAULT_PADDING_Y, DEFAULT_PADDING_X] : _d, _e = _a.labelBgBorderRadius, labelBgBorderRadius = _e === void 0 ? 4 : _e;
    if (!label || (data === null || data === void 0 ? void 0 : data.hideLabel))
        return null;
    var _f = getMidpoint(sourceX, sourceY, targetX, targetY), labelX = _f.x, labelY = _f.y;
    var labelText = String(label);
    var estimatedWidth = estimateLabelWidth(labelText);
    var _g = resolvePadding(labelBgPadding), paddingY = _g[0], paddingX = _g[1];
    var innerStyle = __assign(__assign({ display: 'inline-block', padding: paddingY + "px " + paddingX + "px", borderRadius: labelBgBorderRadius + "px", fontSize: FONT_SIZE_PX + "px", fontWeight: 700, color: '#323130', background: '#ffffff', border: '1px solid #d1d1d1', whiteSpace: 'nowrap', pointerEvents: 'none' }, labelBgStyle), labelStyle);
    return (react_1.default.createElement("foreignObject", { x: labelX - estimatedWidth / 2, y: labelY - WRAPPER_VERTICAL_OFFSET_PX, width: estimatedWidth, height: WRAPPER_HEIGHT_PX, className: "label-edge-wrapper", style: wrapperStyle },
        react_1.default.createElement("div", { style: innerStyle }, label)));
};
exports.LabelEdge = react_1.default.memo(LabelEdgeComponent);
